<template>
  <div id="app" :style="{fontSize: fontSize + 'px', width: overWidth + 'px'}"> 
    <div class="head">
      <img src="./assets/env.png">
    </div>
    <div class="content">
      <h4>联系我们</h4>
      <ol>
        <li>1.邮箱：support@excelliance.cn</li>
        <li>2.电话：021-64480220</li>
        <li>3.QQ技术交流群: 
          <ul class="qq-group">
            <li>苹果版双开助手(I)：859309868</li>
            <li>苹果版双开助手(II)：657948588</li>
          </ul>
        </li>
        <li>4.地址:上海市闵行区田林路1036号科技绿洲三期16号楼4楼</li>
        <li>
          <img src="./assets/address.png">
        </li>
      </ol>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  data () {
    return {
      overWidth: document.documentElement.clientWidth,
      overHeight: document.documentElement.clientHeight,
      fontSize: 14
    }
  },
  watch: {
    overWidth (val) {
      this.overWidth = val
      this.setSize()
    }
  },
  methods: {
    getFontSize () {
      return this.overWidth / 320 * 12
    },
    setSize () {
      if (this.overWidth / this.overHeight > 0.7) { this.overWidth = this.overHeight * 0.7} 
      this.fontSize = this.getFontSize()
    }
  },
  mounted () {
    window.onresize = () => {
      this.overWidth = document.documentElement.clientWidth
      this.overHeight = document.documentElement.clientHeight
    }
  },
  created () {
    this.setSize()
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  font-size: inherit;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  line-height: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  width: 100%;
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  color: #333;
}
li {
  list-style: none;
  margin: 1em 0;
}
button, input {
  outline: none;
  border: none;
}
a {
  text-decoration: none;
  color: inherit;
}
h4 {
  font-size: 1.2em;
  margin-bottom: 1em;
  font-weight: 700;
}
#app {
  font-family: -apple-system-font,
  BlinkMacSystemFont,
  "Helvetica Neue",
  "PingFang SC",
  "Hiragino Sans GB",
  "Microsoft YaHei UI",
  "Microsoft YaHei",
  Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
}
.head img {
  width: 100%;
}
.content {
  padding: 4%;
}
.qq-group {
  padding-left: 1em;
}
.content img {
  width: 100%;
}
</style>
